// @ts-nocheck
/* eslint-disable */
export const flDownloadSimpleIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.125V12.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.25 8.75L10 12.5L13.75 8.75" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.875 11.25V16.25H3.125V11.25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'download-simple' as const
};